// @ts-nocheck
import * as types from '../types';
import { PROMOTION_ISSUING_TYPE_OPTIONS, TRIGGER_TYPE_OPTIONS } from '../../utils/constants';

const initialState = {
    bonus: {},
    step: 0,
    promotionLanguageModal: {
        form: null,
        visible: false,
    },
    bonusesReport: [],
    currentBonus: null,
    promotions: [],
    promotionBonusOffers: [],
    currentPromotion: null,
    promotionForm: {
        promotionIssuingType: PROMOTION_ISSUING_TYPE_OPTIONS[0].value,
        triggerType: TRIGGER_TYPE_OPTIONS[0].value,
        fileId: null,
    },
    bonusWageringReport: {
        data: [],
        totalData: {},
    },
    bonusEngineMonitor: [],
    grandMassBonuses: [],
    playerBonusesReport: {
        data: [],
        totalData: {},
    },
    playerBonusReport: {
        data: [],
        totalData: {},
    },
    bonusOffersReport: {
        data: [],
        totalData: {},
    },
    bonusRegularReport: {},
    playerBonusesModalData: { isVisible: false, userBonusId: '' },
    grandMassBonusesTableData: [],
    grandMassBonusData: [],
};

const bonus = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.BONUS_DATA_CHANGED: {
            return {
                ...state,
                bonus: { ...state.bonus, ...payload },
            };
        }
        case types.NEXT_BONUS_STEP: {
            return {
                ...state,
                step: state.step + 1,
            };
        }
        case types.PREVIOUS_BONUS_STEP: {
            return {
                ...state,
                step: state.step - 1,
            };
        }
        case types.RESET_BONUS_STEP: {
            return {
                ...state,
                step: initialState.step,
            };
        }
        case types.RESET_BONUS_DATA_AND_STEP: {
            return {
                ...state,
                step: initialState.step,
                bonus: initialState.bonus,
                currentBonus: null,
            };
        }
        case types.PROMOTION_ISSUING_TYPE_CHANGED: {
            return {
                ...state,
                promotionForm: {
                    ...state.promotionForm,
                    promotionIssuingType: payload,
                },
            };
        }
        case types.PROMOTION_TRIGGER_TYPE_CHANGED: {
            return {
                ...state,
                promotionForm: {
                    ...state.promotionForm,
                    triggerType: payload,
                },
            };
        }
        case types.PROMOTION_FILE_ID_CHANGED: {
            return {
                ...state,
                promotionForm: {
                    ...state.promotionForm,
                    fileId: payload,
                },
            };
        }
        case types.PROMOTION_FILE_ID_CLEARED: {
            return {
                ...state,
                promotionForm: {
                    ...state.promotionForm,
                    fileId: initialState.fileId,
                },
            };
        }
        case types.PROMOTION_MODAL_CHANGED: {
            return {
                ...state,
                promotionLanguageModal: payload,
            };
        }
        case types.BONUSES_DATA_CHANGED: {
            return {
                ...state,
                bonusesReport: payload,
            };
        }
        case types.CURRENT_BONUS_CHANGED: {
            return {
                ...state,
                currentBonus: payload,
            };
        }
        case types.BONUSES_DATA_CLEARED: {
            return {
                ...state,
                bonusesReport: initialState.bonusesReport,
            };
        }
        case types.BONUS_ENGINE_MONITOR_DATA_CHANGED: {
            return {
                ...state,
                bonusEngineMonitor: payload,
            };
        }
        case types.BONUS_ENGINE_MONITOR_DATA_CLEARED: {
            return {
                ...state,
                bonusEngineMonitor: initialState.bonusEngineMonitor,
            };
        }
        case types.BONUS_WAGERING_REPORT_DATA_CHANGED: {
            return {
                ...state,
                bonusWageringReport: {
                    ...state.bonusWageringReport,
                    ...payload,
                },
            };
        }
        case types.BONUS_WAGERING_REPORT_DATA_CLEARED: {
            return {
                ...state,
                bonusWageringReport: initialState.bonusWageringReport,
            };
        }
        case types.PROMOTIONS_DATA_CHANGED: {
            return {
                ...state,
                promotions: payload,
            };
        }
        case types.PROMOTIONS_DATA_CLEARED: {
            return {
                ...state,
                promotions: initialState.promotions,
            };
        }
        case types.PROMOTION_BONUS_OFFERS_DATA_CHANGED: {
            return {
                ...state,
                promotionBonusOffers: payload,
            };
        }
        case types.CURRENT_PROMOTION_CHANGED: {
            return {
                ...state,
                currentPromotion: payload,
            };
        }
        case types.GRAND_MASS_BONUSES_CHANGED: {
            return {
                ...state,
                grandMassBonuses: payload,
            };
        }
        case types.PLAYER_BONUSES_REPORT_DATA_CHANGED: {
            return {
                ...state,
                playerBonusesReport: {
                    ...state.playerBonusesReport,
                    ...payload,
                },
            };
        }
        case types.PLAYER_BONUSES_REPORT_ALL_DATA_CLEARED: {
            return {
                ...state,
                playerBonusesReport: initialState.playerBonusesReport,
                playerBonusReport: initialState.playerBonusReport,
            };
        }
        case types.PLAYER_BONUS_REPORT_DATA_CHANGED: {
            return {
                ...state,
                playerBonusReport: { ...state.playerBonusReport, ...payload },
            };
        }
        case types.BONUS_OFFERS_REPORT_DATA_CHANGED: {
            return {
                ...state,
                bonusOffersReport: {
                    ...state.bonusOffersReport,
                    ...payload,
                },
            };
        }
        case types.BONUS_OFFERS_REPORT_DATA_CLEARED: {
            return {
                ...state,
                bonusOffersReport: initialState.bonusOffersReport,
            };
        }
        case types.BONUS_REGULAR_REPORT_DATA_CHANGED: {
            return {
                ...state,
                bonusRegularReport: payload,
            };
        }
        case types.BONUS_REGULAR_REPORT_DATA_CLEARED: {
            return {
                ...state,
                bonusRegularReport: initialState.bonusRegularReport,
            };
        }
        case types.PLAYER_BONUSES_REPORT_MODAL_CHANGED: {
            return {
                ...state,
                playerBonusesModalData: {
                    isVisible: payload.isVisible,
                    userBonusId: payload.userBonusId,
                },
            };
        }
        case types.GRAND_MASS_BONUSES_TABLE_DATA_CHANGED: {
            return {
                ...state,
                grandMassBonusesTableData: payload,
            };
        }
        case types.GRAND_MASS_BONUS_CHANGED: {
            return {
                ...state,
                grandMassBonusData: payload,
            };
        }

        default: {
            return state;
        }
    }
};

export default bonus;
